import {
  buildDatosValorizado,
  type FilaValorizable,
} from '@/features/inventario/lib/exportValorizado';
import { buildInventarioWorkbook } from '@/features/inventario/lib/inventarioWorkbook';
import { downloadWorkbook, fechaArchivoHoy } from '@/shared/lib/xlsx';
import type { StockDashboard } from './ventasApi';

/**
 * Descarga el inventario valorizado del dashboard como XLS, reutilizando el
 * MISMO generador que el módulo Inventario (mismo layout, Resumen con
 * fórmulas y detalle completo con Cant.+Valor por estado). Exporta en la
 * moneda de la vista actual (ARS o USD).
 */
export async function descargarStockXls(data: StockDashboard): Promise<void> {
  const filas: FilaValorizable[] = data.detalle.map((r) => ({
    tipo: r.tipo,
    modelo: r.modelo,
    articulo: r.articulo,
    precioVenta: r.precio,
    buckets: {
      prestShow: r.prestShow,
      disponible: r.disponible,
      reservado: r.reservado,
      reservadoParcial: r.reservadoParcial,
      pendienteDespacho: r.pendienteDespacho,
      porIngresar: r.porIngresar,
    },
    totalStock: r.totalStock,
  }));

  const datos = buildDatosValorizado(filas);
  const moneda = data.moneda; // 'ARS' | 'USD'
  const wb = buildInventarioWorkbook(datos, {
    pais: 'Argentina',
    moneda,
    monedaNombre: moneda === 'USD' ? 'dólares' : 'pesos argentinos',
    fecha: data.alFecha,
    vistaFiltrada: false,
  });
  const hoy = fechaArchivoHoy();
  await downloadWorkbook(wb, `inventario_valorizado_${hoy}.xlsx`);
}
